import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_MAINTENANCE_BASE_URL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
    }
});

export default instance;
